(function () {
    'use strict';

    Controllers.ConfirmLoanBankAccountController = class ConfirmLoanBankAccountController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $modalInstance, UsersManager, AnalyticsService) {
            super($scope, $injector);
            this.__objectType = 'LabelComponentController';
            this.$modalInstance = $modalInstance;
            this.requestInProgress = false;
            this.bank_account_data = {};
            this.UsersManager = UsersManager;
            this.AnalyticsService = AnalyticsService;
        }

        dismiss() {
            this.$modalInstance.dismiss();
        }

        onConfirmClick() {
            if (this.confirmBankDetailsForm.$valid && !this.requestInProgress) {
                this.requestInProgress = true;
                this.bank_account_data = {bank_account_data: {type: "BANK", name: this.bankName, account_number: this.accountNumber, routing_number: this.routingNumber}};
                this.UsersManager.signMemberToQwil(this.bank_account_data)
                    .then(function success(resp) {
                        this.AnalyticsService.trackSuccess(this, 'sign member to qwil succeeded');
                        this.requestInProgress = false;
                        this.$modalInstance.close(resp.data.qwil_bank_account_id);
                    }.bind(this))
                    .catch(function failure(resp) {
                        this.errorMessage = resp.data.error_message;
                        this.AnalyticsService.trackError(this, 'sign member to qwil failed', {error: this.errorMessage});
                        this.requestInProgress = false;
                    }.bind(this))
                    .finally(function final() {
                        this.requestInProgress = false;
                    }.bind(this));
            }
        };
    };

}());